// @flow

import ApiObject from '../ApiObject';

// -- constants
import BookingConstants from '../../constants/BookingConstants';

export default class BookingNotificationSettings extends ApiObject {

  emails: Array<String> = [];

  phones: Array<String> = [];

  phoneEnabled: boolean = false;

  emailEnabled: boolean = false;

  type: number = BookingConstants.NotificationType.FOR_ALL;

  isDisabled() {  
    return !this.phoneEnabled && !this.emailEnabled;
  }
}
